module.exports = "<li class=\"profile-tabs\" >\n    <a [ngClass]=\"{'highlight': currentSection == slug}\" class=\"pers\" (click)=\"onNav()\">\n        <span class=\"isCheckmark\" *ngIf=\"complete\"></span><span  class=\"linkHeading\">{{prompt}}</span><i class=\"fa\" [ngClass]=\"!!iconClass ? iconClass : 'fa-file-o-icon'\"></i>\n    </a>\n</li>\n"


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/sidebar.component.html
// module id = ../../../../../src/app/pages/questionnaire/elements/sidebar.component.html
// module chunks = main